<template>
  <table>
    <thead>
      <tr class="p-table__content__top">
        <th class="p-table__content__top--gray fix" />
        <th
          v-for="brandName in brandNames"
          :key="brandName"
          class="p-table__content__top--gray"
        >
          {{ brandName }}
        </th>
        <th
          v-for="competitorBrandName in competitorBrandNames"
          :key="competitorBrandName"
          class="p-table__content__top--green"
        >
          {{ competitorBrandName }}
          <span class="p-table__content__mark">{{ $t('pages.companies.analysis.keywords.labels.comparison.competitor') }}</span>
        </th>
      </tr>
      <tr class="p-table__content__space"><td colspan="3" /></tr>
      <tr class="p-table__content__header">
        <th class="fix">{{ $t('pages.companies.analysis.keywords.labels.comparison.keyword') }}</th>
        <th
          v-for="(brandName, index) in brandNames"
          :key="`store-positiveRate-${ index }`"
        >
          <button
            class="p-table__content__sort"
            :class="orderCss('store', 'positiveRate', index)"
            @click="sortTables('store', 'positiveRate', index)"
          >
            {{ $t('pages.companies.analysis.keywords.labels.comparison.rate') }}
          </button>
        </th>
        <th
          v-for="(competitorBrandName, index) in competitorBrandNames"
          :key="`competitor-positiveRate-${ index }`"
        >
          <button
            class="p-table__content__sort"
            :class="orderCss('competitor', 'positiveRate', index)"
            @click="sortTables('competitor', 'positiveRate', index)"
          >
            {{ $t('pages.companies.analysis.keywords.labels.comparison.rate') }}
          </button>
        </th>
      </tr>
      <tr class="p-table__content__space"><td colspan="3" /></tr>
    </thead>
    <tbody v-if="items && items.length != 0 ">
      <tr v-for="item in itemList" :key="item.id" class="item">
        <td class="fix">
          {{ item.id }}
          <span v-if="type == 'specifyKeywordsComparison'" class="p-table__content__label--specify-keyword">{{ $t('models.keyword.analysis.settings.keyword.rule') }}</span>
        </td>
        <td
          v-for="(brand, index) in item.store.brands"
          :key="`store-positiveRate-${ item.id }-${ index }`"
        >
          <ComparisonRate :item="brand" />
        </td>
        <td
          v-for="(competitorBrand, index) in item.competitor.brands"
          :key="`competitor-positiveRate-${ item.id }-${ index }`"
        >
          <ComparisonRate :item="competitorBrand" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import localeStringMixin from '../../../../mixins/localeStringMixin'
import ComparisonRate from './Rate'

export default {
  name: 'CompaniesAnalysisKeywordsComparisonBrandList',
  components: {
    ComparisonRate
  },
  mixins: [localeStringMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      sortKey: 'positiveRate',
      sortOrder: 'desc',
      sortStore: 'store',
      sortIndex: 0
    }
  },
  computed: {
    itemList() {
      let items = this.items.slice(0)
      let itemsWithNumber = items.filter(v => !this.checkItemData(v))
      const itemsWithoutNumber = items.filter(v => this.checkItemData(v))
      switch (this.sortOrder) {
      case 'asc':
        itemsWithNumber = itemsWithNumber.sort((a, b) => {
          if (this.extractItemData(a) < this.extractItemData(b)) return -1
          if (this.extractItemData(a) > this.extractItemData(b)) return 1
          return 0
        })
        break
      case 'desc':
        itemsWithNumber = itemsWithNumber.sort((a, b) => {
          if (this.extractItemData(a) > this.extractItemData(b)) return -1
          if (this.extractItemData(a) < this.extractItemData(b)) return 1
          return 0
        })
        break
      }

      return itemsWithNumber.concat(itemsWithoutNumber)
    },
    currentSelect() {
      return this.$route.query.select
    },
    brandNames() {
      return this.items[0].store.brands.map(v => v.name)
    },
    competitorBrandNames() {
      return this.items[0].competitor.brands.map(v => v.name)
    }
  },
  methods: {
    sortTables(sortStore, sortKey, index) {
      if (this.sortKey === sortKey && this.sortStore === sortStore && this.sortIndex === index) {
        this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc'
      } else {
        this.sortKey = sortKey
        this.sortStore = sortStore
        this.sortIndex = index
        this.sortOrder = 'desc'
      }
    },
    orderCss(sortStore, key, index) {
      if (!this.sortOrder) return ''
      if (this.sortKey === key && this.sortStore === sortStore && this.sortIndex === index) {
        return this.sortOrder === 'asc' ? 'is-asc' : 'is-desc'
      } else {
        return ''
      }
    },
    extractItemData(item) {
      if (this.sortKey  === 'positiveRate') {
        return this.positiveRate(item[this.sortStore].brands[this.sortIndex])
      }
      return item[this.sortStore].brands[this.sortIndex][this.sortKey]
    },
    total(item) {
      return item.positiveCount + item.negativeCount
    },
    positiveRate(item) {
      return this.total(item) == 0 ? 0 : Math.ceil((item.positiveCount / this.total(item)) * 100)
    },
    checkItemData(item) {
      if (this.sortKey  != 'positiveRate') return false
      const itemData = item[this.sortStore].brands[this.sortIndex]
      return itemData.totalCount == 0 || (itemData.positiveCount == 0 && itemData.negativeCount == 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.p-table__content {
  table {
    table-layout: fixed;
  }

  .fix {
    position: sticky;
    left: 0;
    width: 350px;
    z-index: 1;
    border-right: #e9ebef solid 1px;
  }
  &__top {
    height: 100px;

    th {
      font-size: 14px;
      border: #e9ebef solid 1px;
    }
    &--gray {
      width: 250px;
      background: #f9f9f9;
    }
    &--green {
      width: 250px;
      color: $color-base-a;
      background: $color-competitor-bg;
    }
  }

  %__label {
    display: inline-flex;
    align-items: center;
    height: 20px;
    margin-left: 8px;
    padding: 4px 6px;
    border-radius: 10px;
    color: $color-base-a;
    font-weight: 700;
    font-size: 10px;
    line-height: 1;
  }

  &__mark {
    display: inline-flex;
    align-items: center;
    height: 20px;
    margin-left: 8px;
    padding: 4px 6px;
    border-radius: 10px;
    color: $color-font-base;
    font-weight: 700;
    font-size: 10px;
    line-height: 1;
    background-color: $color-base-a;
  }

  &__label {
    &--specify-keyword {
      @extend %__label;
      background-color: #3a3b3f;
    }
  }
}
</style>
